import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase";
import { notifyTopRight, notifyError } from "../toast/SetToast";
import "./NodeList.css";
import AvailabilityField from "./AvailabilityField";
import { getAvailabilityStatus } from "../../../utils/nodeAvailability";
import { getNodeSharedRoomCount, parseNodeSharedRoomCount } from "./nodeDirectoryUtils";

const EditNodeModal = ({ show, onHide, node, nodeId, onUpdate }) => {
  const [formData, setFormData] = useState({
    nodeIndex: "",
    nodecode: "",
    nodename: "",
    dueDays: "",
    sharedRoomCount: "",
    availabilityStatus: "available",
  });

  useEffect(() => {
    if (node) {
      setFormData({
        nodeIndex: String(node.nodeIndex == null ? "" : node.nodeIndex),
        nodecode: node.nodecode || "",
        nodename: node.nodename || "",
        dueDays: String(node.dueDays == null ? "" : node.dueDays),
        sharedRoomCount: String(getNodeSharedRoomCount(node) == null ? "" : getNodeSharedRoomCount(node)),
        availabilityStatus: getAvailabilityStatus(node),
      });
    }
  }, [node]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    let sharedRoomCount;
    try { sharedRoomCount = parseNodeSharedRoomCount(formData.sharedRoomCount, formData); }
    catch (error) { notifyError(error.message); return; }
    const updatedData = {
      nodeIndex: formData.nodeIndex.trim(),
      nodecode: formData.nodecode.trim(),
      nodename: formData.nodename.trim(),
      dueDays: formData.dueDays.trim(),
      sharedRoomCount,
      availabilityStatus: formData.availabilityStatus,
    };

    if (
      !updatedData.nodeIndex ||
      !updatedData.nodecode ||
      !updatedData.nodename ||
      !updatedData.dueDays
    ) {
      notifyError("กรุณากรอกข้อมูลให้ครบ");
      return;
    }

    try {
      const nodeRef = doc(db, "nodes", nodeId);
      await updateDoc(nodeRef, updatedData);
      onUpdate(nodeId, updatedData);
      notifyTopRight("แก้ไขข้อมูลสำเร็จ");
      onHide();
    } catch (err) {
      notifyError("แก้ไขข้อมูลผิดพลาด", err.message || err);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="node-editor">
      <Modal.Header closeButton>
        <Modal.Title>Edit Node</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className="node-editor__fields">
          <Form.Group controlId="edit-node-index">
            <Form.Label>Node Index</Form.Label>
            <Form.Control
              type="text"
              value={formData.nodeIndex}
              onChange={handleChange("nodeIndex")}
            />
          </Form.Group>

          <Form.Group controlId="edit-node-code">
            <Form.Label>Node Code</Form.Label>
            <Form.Control
              type="text"
              value={formData.nodecode}
              onChange={handleChange("nodecode")}
            />
          </Form.Group>

          <Form.Group controlId="edit-node-name">
            <Form.Label>Node Name</Form.Label>
            <Form.Control
              type="text"
              value={formData.nodename}
              onChange={handleChange("nodename")}
            />
          </Form.Group>

          <Form.Group controlId="edit-node-due-days">
            <Form.Label>Due Days</Form.Label>
            <Form.Control
              type="text"
              value={formData.dueDays}
              onChange={handleChange("dueDays")}
            />
          </Form.Group>
          <Form.Group controlId="edit-node-shared-rooms">
            <Form.Label>Shared Rooms</Form.Label>
            <Form.Control type="number" min="1" step="1" value={formData.sharedRoomCount} onChange={handleChange("sharedRoomCount")} />
            <Form.Text className="text-muted">Optional. Shared across this node's hospitals. CHG uses 9 shared rooms when blank; other nodes use each hospital's room count.</Form.Text>
          </Form.Group>
          <AvailabilityField
            id="edit-node-availability"
            isNode
            value={formData.availabilityStatus}
            onChange={handleChange("availabilityStatus")}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditNodeModal;
